<template>
  <ModalFilterTransaction v-if="modalShowFilterTransaction" @closeModal="closeModal" @submitFilter="submitFilter" />
  <IndexView />
  <section class="p-6">
    <PageTitle title="Riwayat Transaksi" />
    <div class="bg-white rounded-lg py-6 px-5 shadow-lg">
      <div v-if="!isConnected" class="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4" role="alert">
        <p class="font-bold">Connection Status</p>
        <p>Attempting to connect to real-time updates...</p>
      </div>
      <div id="table-header" class="mb-5 flex justify-between items-end">
        <div class="mb-5 flex justify-between">
          <AddButton to_url="#" button_text="Filter" button_class="text-base py-2 font-medium" @click="showModal" />
        </div>
      </div>
      <div v-if="isLoading" class="flex justify-center items-center py-4">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
      <div v-else class="overflow-x-auto">
        <div class="inline-block min-w-full align-middle">
          <div class="overflow-hidden shadow-lg rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-color-1">
                <tr>
                  <th class="py-3 px-3 border-b text-left">No</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Kode
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Nama Pelanggan
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Order Type
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Meja
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Marketing
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Metode pembayaran
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Sub Total
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">tax</th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Service Charge
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Diskon
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Grand Total
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Keterangan
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Bayar
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Waktu Transaksi
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Status
                  </th>
                  <th class="py-3 px-3 border-b text-color-4 text-left">
                    Cash Register
                  </th>
                  <th class="py-3 px-3 border-b text-color-4">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="transaction in filteredSalesOrders" :key="transaction.id">
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.id }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.code }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.customer_name }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.order_type }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.allTables?.find(t => t.id == transaction.table_id)?.name }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.allMarketings?.find(m => m.id == transaction.marketing_id)?.name }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ this.allPaymentMethods?.find(pm => pm.id == transaction.payment_method_id)?.name }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatRupiah(transaction.sub_total) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatRupiah(transaction.tax) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatRupiah(transaction.service_charge) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatRupiah(transaction.global_discount_amount) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatRupiah(transaction.grand_total) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.note }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.payment_amount }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatDate(transaction.createdAt) }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ transaction.status }}
                  </td>
                  <td class="py-3 px-3 border-b text-left">
                    {{ formatDate(transaction.cash_register.time_start) }}
                  </td>
                  <td class="py-3 px-3 border-b">
                    <RouterLink :to="{ path: '/order', query: { orderId: transaction.id } }"
                      class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <ShoppingCartIcon class="h-5 w-5" />
                    </RouterLink>
                    <RouterLink :to="{ path: '/payment', query: { orderId: transaction.id } }"
                      class="border border-gray-400 hover:border-blue-700 hover:bg-blue-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                      <EyeIcon class="h-5 w-5" />
                    </RouterLink>
                  </td>
                </tr>
              </tbody>
            </table>
            <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import IndexView from "@/views/IndexView.vue";
import { EyeIcon, ShoppingCartIcon } from "@heroicons/vue/24/solid";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalFilterTransaction from "./modals/ModalFilterTransaction.vue";
import { io } from "socket.io-client";
import { mapGetters } from "vuex";
import PaginationButtons from "@/components/PaginationButtons.vue";
import { formatDate } from "@/helpers/formatTime";
import { formatRupiah } from "@/helpers/formatRupiah";

export default {
  name: "TransactionView",
  components: {
    PageTitle,
    IndexView,
    ShoppingCartIcon,
    AddButton,
    ModalFilterTransaction,
    EyeIcon,
    PaginationButtons,
  },
  data() {
    return {
      modalShowFilterTransaction: false,
      isBlur: false,
      listTransaction: [],
      socket: null,
      message: "",
      messages: [],
      isConnected: false,
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      filter: {}
    };
  },
  async created() {
    this.connectWebSocket();
    this.fetchSalesOrders();
    this.fetchAdditionalData();
  },
  computed: {
    ...mapGetters('sales_orders', ['allSalesOrders']),
    ...mapGetters('tables', ['allTables']),
    ...mapGetters('marketings', ['allMarketings']),
    ...mapGetters('payment_methods', ['allPaymentMethods']),
    filteredSalesOrders() {
      if (this.filter.rangeDate) {
        return this.allSalesOrders.filter((so) => {
          let start_date = new Date(this.filter.rangeDate[0].getTime() + 25200000 ); // Start from 00:00:00
          let end_date = new Date(new Date(this.filter.rangeDate[1]).getTime() + 25200000 + 86399000); // Plus 23:59:59 (in milliseconds)
          let dateFilter = new Date(so.createdAt).getTime() / 1000;
          let startDate = start_date.getTime() / 1000;
          let endDate = end_date.getTime() / 1000;
          return dateFilter >= startDate && dateFilter <= endDate;
        });
      }

      return this.allSalesOrders;
    }
  },
  beforeUnmount() {
    try {
      if (this.socket) {
        // Remove all listeners to prevent memory leaks
        this.socket.removeAllListeners();
        this.socket.disconnect();
        this.socket = null;
      }
      this.isConnected = false;
      this.listTransaction = [];
      this.messages = [];
    } catch (error) {
      console.error("Error during cleanup:", error);
    }
  },
  watch: {
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchSalesOrders({ page: newVal });
      },
    },
  },
  methods: {
    formatRupiah,
    formatDate,
    async fetchSalesOrders(params = {}) {
      if (!params.page) params.page = this.currentPage;
      if (!params.limit) params.limit = 50;
      try {
        const { pagination } = await this.$store.dispatch('sales_orders/fetchSalesOrders', params);
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAdditionalData() {
      this.$store.dispatch('tables/fetchTables', { limit: 1000 });
      this.$store.dispatch('marketings/fetchMarketings', { limit: 1000 });
      this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
    },
    connectWebSocket() {
      try {
        this.socket = io(process.env.VUE_APP_WEBSOCKET_URL, {
          reconnection: true, // Enable auto-reconnection
          reconnectionAttempts: 5, // Maximum number of reconnection attempts
          timeout: 10000, // Connection timeout in milliseconds
        });

        this.socket.on("connect_error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.socket.on("disconnect", (reason) => {
          this.messages.push(reason);
          this.isConnected = false;
        });

        // Menerima pesan dari server
        this.socket.on("serverMessage", (data) => {
          this.handleWebSocketMessage(data);
          this.messages.push(data.message);
        });

        this.socket.on("welcome", (data) => {
          this.messages.push(data.message);
        });

        this.socket.on("new_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("update_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("delete_items", (order) => {
          this.handleWebSocketMessage(order);
        });

        this.socket.on("connect", () => {
          this.isConnected = true;
        });

        this.socket.on("error", (error) => {
          this.messages.push(error.message);
          this.isConnected = false;
        });

        this.handleReconnect();
      } catch (error) {
        this.isConnected = false;
      }
    },
    sendMessage() {
      // Kirim pesan ke server
      this.socket.emit("clientMessage", this.message);
      this.message = ""; // Reset input
    },
    handleWebSocketMessage(data) {
      this.isLoading = true;
      try {
        let index;

        // Validasi data terlebih dahulu
        if (!data || !data.type) {
          return;
        }

        switch (data.type) {
          case "INITIAL_DATA":
            if (Array.isArray(data.transactions)) {
              this.listTransaction = data.transactions;
              this.fetchSalesOrders();
            } else {
              console.warn("Invalid transactions data format:", data);
            }
            break;
          case "NEW_ITEMS":
            if (data.items && data.route == "sales-order") {
              this.listTransaction.unshift(data.items);
              this.fetchSalesOrders();
            }
            break;
          case "UPDATE_ITEMS":
            if (data.items && data.items.id && data.route == "sales-order") {
              index = this.listTransaction.findIndex(
                (t) => t.id === data.items.id
              );
              if (index !== -1) {
                this.listTransaction.splice(index, 1, data.items);
              }
              this.fetchSalesOrders();
            }
            break;
          case "DELETE_ITEMS":
            if (data.id && data.route == "sales-order") {
              this.listTransaction = this.listTransaction.filter(
                (transaction) => String(transaction.id) !== String(data.id)
              );
              this.fetchSalesOrders();
            }
            break;
          default:
            console.warn("Unknown message type:", data.type);
        }
      } catch (error) {
        console.error("Error handling websocket message:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleReconnect() {
      if (this.socket) {
        this.socket.on("reconnect_attempt", (attemptNumber) => {
          console.log(`Reconnection attempt ${attemptNumber}`);
        });

        this.socket.on("reconnect", () => {
          console.log("Reconnected successfully");
          this.isConnected = true;
          // Mungkin perlu memuat ulang data
          this.socket.emit("requestInitialData");
        });

        this.socket.on("reconnect_failed", () => {
          console.log("Failed to reconnect");
          this.isConnected = false;
        });
      }
    },
    showModal() {
      this.modalShowFilterTransaction = true;
      this.isBlur = true;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowFilterTransaction = false;
        this.isBlur = false;
      }, 200);
    },
    submitFilter(filter) {
      this.filter = filter;
      let params = {};

      if (this.filter.capacity) {
        params.capacity = this.filter.capacity;
      }

      if (this.filter.type) {
        params.order_type = this.filter.type;
      }

      if (this.filter.status) {
        params.status = this.filter.status;
      }

      if (this.filter.marketing_id) {
        params.marketing_id = this.filter.marketing_id;
      }

      if (this.filter.payment_method_id) {
        params.payment_method_id = this.filter.payment_method_id;
      }

      if (this.filter.table_id) {
        params.table_id = this.filter.table_id;
      }

      if (this.filter.cash_register_id) {
        params.cash_register_id = this.filter.cash_register_id;
      }

      if (this.filter.global_discount_id) {
        params.global_discount_id = this.filter.global_discount_id;
      }

      this.fetchSalesOrders(params);
      this.updateFilter(filter);
    },
    updateFilter(filter) {
      this.filter = filter;
    },
  },
};
</script>
